import React, { FC, useEffect, useRef, useState, Dispatch, useMemo } from 'react';
import { Accordion, Badge, Box, Flex, Group, List, Paper, Radio, Space, Text, Tooltip, UnstyledButton } from '@mantine/core';
import classNames from 'classnames';
import { Link2, Eye, ChevronUp, ChevronDown, ChevronsUp, Copy, Share2, Flag, ArrowUpRight, ArrowLeft, ArrowRight, ArrowDown, ChevronLeft, ChevronRight, ArrowUp, Image, UserCheck, Smartphone, Settings, Menu, MoreVertical, QuestionCircle } from '@geist-ui/icons';
import { ReactComponent as Operable } from 'src/assets/svg/Operable.svg';
import { ReactComponent as Understandable } from 'src/assets/svg/Understandable.svg';
import { ReactComponent as Robust } from 'src/assets/svg/Robust.svg';

import styles from './styles.module.scss';
import { FireCopiedLinkfilterByPage, IReport, reauditCriteriaPages, setCopiedLinkfilterByPage, singlePageAudit } from 'src/store';
import { useAppDispatch } from 'src/store/hooks';

import { AutomatedAuditLoader, Button, Select, SiteLoader, Textarea } from '@common/components';
import { setTooltipTimeout } from 'src/helpers/setTooltipTimeout';
import { useTranslation } from 'react-i18next';
import { useAlert } from '@common/hooks';
import AlertTriangleFill from '@geist-ui/icons/alertTriangleFill';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useMediaQuery } from '@mantine/hooks';
import { apiInstance } from 'src/services/interceptor';
import { useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { ReactComponent as EmptyTable } from 'src/assets/svg/empty-table.svg';

import Slider from 'react-slick';
import { totalImpactLabel } from 'src/helpers/IssuesTable';
interface TableCellProps {
  rowData: IReport;
  field: string;
  open?: boolean;
  className?: string;
  setOpen?: (open: boolean) => void;
  rowIndex: number;
}

type scenariosType = {
  id: number | null,
  message: string,
  severity: string,
  complianceLevel: string,
  nbrOfIssues: number | null,
}

type selectedPageDataType = {
  id: number,
  criteria: string,
  messageIndex: number,
  type: string,
  selector: string,
  context: string,
  status: string,
  message: string,
  issueType: string,
  severity: string,
  priority: string,
  score: number,
  complianceLevel: string,
  version: string,
  screenshot: string,
  pageScreenshot: string,
  pageUrl: string,
  disabilities: Array<string>
}

type ArrowProps = {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

const CustomPrevArrow: FC<ArrowProps> = ({ className, style, onClick }) => {
  return onClick !== null ? (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <ChevronLeft color="#5b5eff" size={30} />
    </div>
  ) : null;
};

const CustomNextArrow: FC<ArrowProps> = ({ className, style, onClick }) => {
  return onClick !== null ? (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <ChevronRight color="#5b5eff" size={30} />
    </div>
  ) : null;
};
const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: <CustomPrevArrow className={styles['slick-prev']} />,
  nextArrow: <CustomNextArrow className={styles['slick-next']} />,

}
interface TableReportProps {
  report: IReport[];
}

const icons: { [key: string]: JSX.Element } = {
  warning: <AlertTriangleFill color="#D88803" stroke="#FFFFFF" aria-hidden />,
  critical: <AlertTriangleFill color="#A80000" stroke="#FFFFFF" aria-hidden />,
  high: <ChevronsUp color="#C91717" aria-hidden />,
  low: <ChevronDown color="#3CA661" aria-hidden />,
  medium: <ChevronsUp color="#D88803" aria-hidden />,
  Perceivable: <Eye size={24} color="#264547" aria-hidden />,
  Operable: <Operable height={'24px'} aria-hidden />,
  Understandable: <Understandable height={'24px'} aria-hidden />,
  Robust: <Robust height={'24px'} aria-hidden />,
  pageUrl: <Link2 color="#5b5eff" aria-hidden />,
  Надійність: <Robust height={'24px'} aria-hidden />,
  Керування: <Operable height={'24px'} aria-hidden />,
  високий: <ChevronsUp color="#C91717" aria-hidden />,
  середній: <ChevronsUp aria-hidden />,
  критичний: <AlertTriangleFill color="#D88803" stroke="#FFFFFF" aria-hidden />,
  'Придатність до сприйняття': <Eye size={24} color="#264547" aria-hidden />,
};

const CriteriaCell = ({ rowData, field }: TableCellProps): JSX.Element => {
  return (
    <div className={styles['criteriaCell']}>
      <span className={styles['criteriaCellText']}>{rowData[field as keyof IReport] as string}</span>
    </div>
  );
};

const ComplianceCell = ({ rowData, field }: TableCellProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const { showAlert } = useAlert();
  const { trackingNumber: trackingNbr, reportId } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const { id, tracking_number, runId } = useParams();
  const handleSinglePageAudit = () => {
    if (!id || !trackingNbr || !reportId || !id) {
      showAlert({
        id: 'run-audit-error-page',
        title: 'Somthing went wrong!!',
        message: 'Enabel to run single page audit!!',
        variant: 'error'
      });
      return
    }
    dispatch(singlePageAudit({
      site_id: id,
      tracking_number: trackingNbr,
      report_id: reportId,
      pageURL: id,
    }));
  }
  return (
    // <div className={styles['complianceCell']} >
      <Tooltip label="Re-audit pages this criterion failed on" >
        {/* <div> */}
          <Button
            ariaLabel="Re-audit pages this criterion failed on"
            color="dark-green" // Use a valid color value as defined in the component's API
            onClick={() => handleSinglePageAudit()}                   >
            Re-audit
          </Button>
        {/* </div> */}
      </Tooltip>

    // </div>
  );
};

const StatusCell = ({ rowData, field }: TableCellProps): JSX.Element => {
  const [t] = useTranslation('automatedReports');

  return (
    <div className={styles['statusCell']}>
      <span>{t(rowData[field as keyof IReport] as string)}</span>
    </div>
  );
};

const IconCell = ({ className, rowData, field }: TableCellProps): JSX.Element => {
  return (
    <div className={classNames(styles['icon-cell'], className)}>
      {icons[rowData[field as keyof IReport] as string] || icons[field]}
      <span>{rowData[field as keyof IReport] as string}</span>
    </div>
  );
};

const IconCellType = ({ className, rowData, field }: TableCellProps): JSX.Element => {
  return (
    <div className={classNames(styles['icon-cell'], className)}>
      {icons[rowData[field as keyof IReport] as string] || icons[field]}
    </div>
  );
};
const IconCellSevirity = ({ className, rowData, field }: TableCellProps): JSX.Element => {
  return (
    <div style={{ justifyContent: 'center' }} className={classNames(styles['icon-cell'], className)}>
      <span>{rowData[field as keyof IReport] as string}</span>
    </div>
  );
};

const IconsActions = ({ className, rowData, field }: TableCellProps): JSX.Element => {
  return (
    <div className={classNames(styles['icon-cell'], className)}>
      <Share2 />
      <Flag />
    </div>
  );
};

const BtnCell = ({ open, setOpen, rowData }: TableCellProps): JSX.Element => {
  const [t] = useTranslation('automatedReports');
  return (
    <UnstyledButton
      style={{
        backgroundColor: open ? '#5b5eff' : 'white',
      }}
      className={styles.circelBorder} aria-label={`Click here for more information about  ${rowData?.criteriaName}`} onClick={() => setOpen && setOpen(!open)}>
      {open ? <ChevronUp color='white' /> : <ChevronDown />}
    </UnstyledButton>
  );
};

const PageUrlCell = ({ className, rowData, field }: TableCellProps): JSX.Element => {
  const [opened, setOpened] = useState(false);
  const widgetContainerRef = useRef<HTMLDivElement>(null);
  const { showAlert } = useAlert();

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (opened) {
      setTooltipTimeout(2000).then(() => {
        setOpened(false);
      });
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [opened]);

  const handleCopyClick = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(rowData[field as keyof IReport] as string);
      setOpened(true);
    } catch (err) {
      showAlert({
        id: 'copy-error',
        title: t('errorTitle'),
        message: `${c('failedToCopy')}`,
        variant: 'error',
      });
    }
  };
  const [t] = useTranslation('common');
  const [c] = useTranslation('automatedReports');
  return (
    <div ref={widgetContainerRef} className={classNames(styles['icon-cell'], className)}>
      <Tooltip label={`${c('linkCopied')}`} opened={opened} withArrow>
        <UnstyledButton onClick={handleCopyClick}>
          <Copy color={'#5b5eff'} size={20} aria-label="copy icon" />
        </UnstyledButton>
      </Tooltip>
      <a
        className={styles.link}
        target={'_blank'}
        href={rowData[field as keyof IReport] as string}
        rel="noreferrer"
        aria-label={`${t('opensInNewTab')}`}>
        {rowData[field as keyof IReport] as string}
      </a>
    </div>
  );
};


const PagesCount = ({ className, rowData, field }: TableCellProps): JSX.Element => {
  const { latestDashboard } = useAppSelector((state) => state.automatedReports, shallowEqual);

  return (
    <div style={{
      justifyContent: 'center',
    }} className={classNames(styles['icon-cell'], className)}>
      {latestDashboard?.pagesScanned}
    </div>
  );
};

const DisbilityList = ({ className, rowData, field }: TableCellProps): JSX.Element => {
  return (
    <Flex justify={"center"} align={"center"} gap={"xs"}>
      <Eye />
      <UserCheck />
      <Smartphone />
      <Settings />
    </Flex>
  );
};

const ActionBtns = ({ className, rowData, field }: TableCellProps): JSX.Element => {
  return (
    <Flex justify={"center"} align={"center"} gap={"xs"}>
      <Share2 />
      <MoreVertical />
    </Flex>
  );
};
const TotalImpact = ({ className, rowData, field, rowIndex }: TableCellProps): JSX.Element => {
  const issues = rowData['nbrOfIssues' as keyof IReport] as number
  const pages = rowData['pages' as keyof IReport] as number
  let totalImpact = 0

  if (issues && pages) {
    totalImpact = pages / issues

  }

  const [cachedValue, setCachedValue] = useState(totalImpact);
  const label = totalImpactLabel(cachedValue);

  return (
    <Flex justify={"center"} align={"center"} gap={"xs"}>
      <p className={`rowIndex-${rowData.criteriaCode?.replaceAll('.', '')}`}>{label}</p>
    </Flex>
  );
};

const elements: { [key: string]: (props: TableCellProps) => JSX.Element } = {
  criteria: (props: TableCellProps) => <CriteriaCell {...props} />,
  complianceLevel: (props: TableCellProps) => <ComplianceCell {...props} />,
  status: (props: TableCellProps) => <StatusCell {...props} />,
  severity: (props: TableCellProps) => <IconCellSevirity className={styles.start} {...props} />,
  issueType: (props: TableCellProps) => <IconCellType className={styles.start} {...props} />,
  pageUrl: (props: TableCellProps) => <PageUrlCell {...props} />,
  action: (props: TableCellProps) => <BtnCell {...props} />,
  icons: (props: TableCellProps) => <IconsActions {...props} />,
  pages: (props: TableCellProps) => <PagesCount {...props} />,
  disbility: (props: TableCellProps) => <DisbilityList {...props} />,
  TotalImpact: (props: TableCellProps) => <TotalImpact {...props} />,
  actionBtns: (props: TableCellProps) => <ActionBtns {...props} />
};

const TableCell = (props: TableCellProps): JSX.Element => {
  const { rowData, field, rowIndex } = props;

  return elements[field] ? (
    <div
      // colSpan={field === 'complianceLevel' ? 3 : 1}
      className={classNames(styles['table-cell'], styles[`${field}-cell`])}> {elements[field](props)}</div>
  ) : (
    <div
      // colSpan={field === 'complianceLevel' ? 3 : 1}
      className={classNames(styles['table-cell'], styles[`${field}-cell`])}
      {...(!rowIndex && field === 'id' ? { tabIndex: -1 } : {})}>
      {field === 'message' ? (
        <span className={styles['truncate-multi-lines']}>{rowData[field as keyof IReport] as string}</span>
      ) : (
        <>{rowData[field as keyof IReport] as string}</>
      )}
    </div>
  );
};

interface ISelectData {
  value: string;
  label: string;
}
const TableRow: FC<{ rowData: IReport; rowIndex: number; }> = ({ rowData, rowIndex }): JSX.Element => {
  const { id, tracking_number, runId } = useParams();
  const [open, setOpen] = React.useState(false);
  const dispatch = useAppDispatch();
  const { trackingNumber: trackingNbr, reportId, latestDashboard } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const [selectedPageData, setSelectedPageData] = useState<selectedPageDataType[]>([]);

  const columnToDisplay = [
    'action',
    'criteriaName',
    'nbrOfIssues',
    'pages',
    'severity',
    // 'actionBtns',
    // 'TotalImpact',
    // 'complianceLevel' // action btns
  ];
  const widgetContainerRef = useRef<HTMLDivElement>(null);
  const [opened, setOpened] = useState(false);
  const { showAlert } = useAlert();
  const [t] = useTranslation('widget');
  const [c] = useTranslation('automatedReports');
  const [scenario, setScenario] = useState<number | null>(null);
  const { tenantId } = useAppSelector((state) => state.user.data, shallowEqual);
  const [criteriaPages, setCriteriaPages] = useState<any>(null);
  const [isselectedPageDataLoading, setIsselectedPageDataLoading] = useState(false)
  const [criteriaDescription, setCriteriaDescription] = useState("")
  const [subOpenIndex, setSubOpenIndex] = useState<number | null>(null);
  const [showPageDropDown, setShowPageDropDown] = useState(false);
  const [showIssue, setShowIssue] = useState(false);
  const [showIssueIndex, setShowIssueIndex] = useState<number | null>(null);
  const { loading } = useAppSelector((state) => state.automatedReports, shallowEqual);
  const navigate = useNavigate()

  const [openedTooltipIndex, setOpenedTooltipIndex] = useState(-1);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (opened) {
      setTooltipTimeout(2000).then(() => {
        setOpened(false);
      });
    }
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [opened]);

  const [leadingCriteria, setLeadingCriteria] = useState(false)

  const [searchParams, setSearchParams] = useSearchParams();
  const siteUUID = searchParams.get('siteUUID')
  
  useEffect(() => {
    const getSitesUrl = async () => {
      try {

        setLeadingCriteria(true)
        const criteria = rowData.criteriaCode;
        const data: any = await apiInstance.post(`reporttool/audit/get-pages-based-on-criterias-cenario`, { reportId, criteria, scenario,siteUUID });
        if (data.data.statusCode != 200) {
          throw 'error';
        }
        // Set the updated pages into the state
        setCriteriaPages(data.data.pagesOfCriteriaScenario?.pages);
        if (data?.data?.pagesOfCriteriaScenario?.pages?.length > 0) {
          const fisrtPage = data?.data?.pagesOfCriteriaScenario?.pages[0]
          showCriteriaPage(fisrtPage.id)
        }
      } catch (error) {
        console.log(error);

      } finally {
        setLeadingCriteria(false)
      }
    }
    if (scenario || scenario == 0) {
      getSitesUrl()
    }
  }, [scenario])

  const handleCopyClick = async (content: any, index: number): Promise<void> => {
    try {
      await navigator.clipboard.writeText(content);
      setOpened(true);
      setOpenedTooltipIndex(index);

      setTooltipTimeout(2000).then(() => {
        setOpenedTooltipIndex(-1);
      });
    } catch (err) {
      showAlert({
        id: 'copy-error',
        title: t('errorTitle'),
        message: `${t('failedToCopy')}`,
        variant: 'error',
      });
    }
  };
  const isMobile = useMediaQuery('(max-width: 768px)');

  const showCriteriaPage = async (page_id: string) => {
    try {
      // console.log(`showCriteria`);
      const criteria = rowData.criteriaCode;
      const data = {
        // tenantId,
        // siteId: id,
        // trackingNumber: tracking_number,
        runId,
        criteria,
        caseId: scenario,
        pageId: page_id,
        siteUUID
      }
      const result = await apiInstance.post(`/reporttool/audit/page-issues`, data);
      if (result?.data) {
        setSelectedPageData(result.data)
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsselectedPageDataLoading(false)
    }
  }

  const clearToolTip = () => {
    setOpenedTooltipIndex(-1)
  }
  const handleSinglePageAudit = (siteUrl: string) => {
    if (!id || !trackingNbr || !reportId || !siteUrl) {
      showAlert({
        id: 'run-audit-error-page',
        title: 'Somthing went wrong!!',
        message: 'Enabel to run single page audit!!',
        variant: 'error'
      });
      return
    }
    dispatch(singlePageAudit({
      site_id: id,
      tracking_number: trackingNbr,
      report_id: reportId,
      pageURL: siteUrl,
    }));
  }

  const [randomValue, setRandomValue] = useState(null);
  const [isAscending, setIsAscending] = useState(true);
  const [isAscending2, setIsAscending2] = useState(true);
  const [isAscending3, setIsAscending3] = useState(true);
  const [issuesStatus, setIssuesStatus] = useState<ISelectData[]>([
    { value: 'Passed', label: 'Passed' },
    { value: 'Failed', label: 'Failed' },
    { value: 'InProgress', label: 'In Progress' }
  ]);
  const handleFilterByImpact = (id: string, sortOrder: string) => {
    // Sort the pages based on the 'impact' field
    if (!criteriaPages) return
    const sortedPages = criteriaPages.sort((a: any, b: any) => {
      if (sortOrder === 'asc') {
        return a.impact - b.impact; // Ascending order
      } else if (sortOrder === 'desc') {
        return b.impact - a.impact; // Descending order
      }
      return 0; // Default: no sorting if sortOrder is invalid
    });

    // Update the state with the sorted pages
    setCriteriaPages(sortedPages);
  };


  const handleFilterTotalImpact = (id: string, sortOrder: string) => {

    const sortedPages = criteriaPages.sort((a: any, b: any) => {
      if (sortOrder === 'asc') {
        return a.totalImpact - b.totalImpact; // Ascending order
      } else if (sortOrder === 'desc') {
        return b.totalImpact - a.totalImpact; // Descending order
      }
      return 0; // Default: no sorting if sortOrder is invalid
    });

    // Update the state with the sorted pages
    setCriteriaPages(sortedPages);
  };
  const handleFilterScore = (id: string, sortOrder: string) => {

    const sortedPages = criteriaPages.sort((a: any, b: any) => {
      if (sortOrder === 'asc') {
        return a.score - b.score; // Ascending order
      } else if (sortOrder === 'desc') {
        return b.score - a.score; // Descending order
      }
      return 0; // Default: no sorting if sortOrder is invalid
    });

    // Update the state with the sorted pages
    setCriteriaPages(sortedPages);
  };
  const handleFilterByIssues = (id: string, sortOrder: string) => {

    const sortedPages = criteriaPages.sort((a: any, b: any) => {
      if (sortOrder === 'asc') {
        return a.nbrOfIssues - b.nbrOfIssues; // Ascending order
      } else if (sortOrder === 'desc') {
        return b.nbrOfIssues - a.nbrOfIssues; // Descending order
      }
      return 0; // Default: no sorting if sortOrder is invalid
    });

    // Update the state with the sorted pages
    setCriteriaPages(sortedPages);
  };

  async function reauditSpecificPagesCriterias(data: IReport) {

    if (!criteriaPages) {
      return
    }
    const pagesUrls = criteriaPages.map((page: any) => page.link);
    // console.log(data);

    dispatch(reauditCriteriaPages({
      site_id: id,
      tracking_number: trackingNbr,
      report_id: reportId,
      specificPages: pagesUrls,
      specificCriterias: [data?.criteriaCode]
    }))

  }
  const handleStatusChange = (index: number, newValue: string) => {
    const updatedStatuses = [...issuesStatus]; // Shallow copy of state
    updatedStatuses[index] = { ...updatedStatuses[index], value: newValue }; // Update the specific status at the given index immutably
    setIssuesStatus(updatedStatuses); // Update the state
  };

  // const [filterByPageVal, setFilterByPageVal] = useState('');

    const handleCopy = async (link: string) => {     
      try {
        await navigator.clipboard.writeText(link);
        // setFilterByPageVal(link);
        dispatch(FireCopiedLinkfilterByPage(link));
        // alert('Link copied!');
      } catch (err) {
        showAlert({
          id: 'copy-error',
          title: t('errorTitle'),
          message: `${c('failedToCopy')}`,
          variant: 'error',
        });
      }
    };

    
  return (
    <>

      <div role='rowgroup' className={`${styles['table-row']}`}>
        {!isMobile &&
          columnToDisplay.map((i, index) => (
            <TableCell
              key={index}
              rowIndex={rowIndex}
              {...(!rowData[i as keyof IReport] && { open: open })}
              {...(!rowData[i as keyof IReport] && { setOpen: setOpen })}
              field={i}
              rowData={rowData}></TableCell>
          ))
        }

        {isMobile && (
          <div
            // colSpan={4}
            style={{
              width: '100%',
              padding: '5px'
            }}>
            <section className={styles.columnToDisplayMobile}>
              <div className={styles.leftSide}>
                <div className={styles.justifyBetween}>
                  <div>
                    <UnstyledButton className={styles.circelBorder} aria-label={`Click here for more information about ${rowData?.criteriaName}`} onClick={() => setOpen && setOpen(!open)}>
                      {open ? <ChevronUp /> : <ChevronDown />}
                    </UnstyledButton>
                  </div>
                  <div>
                    <h2>{rowData.criteriaName}</h2>
                    <Link to={"#"} target='_blank' aria-label="open in new tab" >{rowData?.pageUrl}</Link>
                  </div>
                </div>
                {/* <div>
                  <Share2/>
                  <Flag/>
                </div> */}
              </div>
              <div className={styles.rightSide}>
                <div className={`${styles.flex} ${styles.gap2} ${styles.justifyEnd} `}>
                  <p>{rowData?.issueType}</p>
                  <p>{rowData?.severity}</p>
                  <p>{rowData?.complianceLevel}</p>
                  <p>{rowData?.nbrOfIssues}</p>
                </div>
              </div>
            </section>
          </div>
        )}
      </div>
      {open && (
        <>
          {rowData?.scenarios?.map((item: scenariosType, _index: number) => {
            return (
              <>
                <div role='cell' className={styles.SubRowCell} key={_index}>
                  <div className={styles.iconsTd} onClick={() => {
                    setSubOpenIndex((prevState) => prevState === _index ? null : _index); // Toggle dropdown for clicked item
                    setScenario(item.id);
                    setCriteriaDescription(item.message);
                    setShowPageDropDown(!showPageDropDown)
                    leadingCriteria && setLeadingCriteria(false)
                  }}>
                    <UnstyledButton className={styles.circelBorder}
                      aria-label={`${subOpenIndex === _index
                        ? 'Close this scenario and hide the list of pages that meet this criteria'
                        : `${item.message},Open this scenario to view the list of pages that meet this criteria`
                        }`}
                        role='cell'
                      style={{
                        backgroundColor: subOpenIndex === _index ? '#5b5eff' : 'white'
                      }} >
                      {subOpenIndex === _index ? <ChevronUp /> : <ChevronDown />}
                    </UnstyledButton>
                  </div>
                  <div role='cell'><p> <strong>Message : </strong> {item.message}.</p></div>
                  <div role='cell'>{rowData.nbrOfIssues}</div>
                  <div role='cell'>{latestDashboard?.pagesScanned}</div>
                  <div role='cell'>{item.severity}</div>
                  {/* <div role='cell'>
                      <Button loading={loading} ariaLabel={`Re-audit pages for this Senairo`} color='dark-green' 
                              onClick={() => reauditSpecificPagesCriterias( rowData) }               
                            >
                        Re-audit
                      </Button>
                    </div> */}
              </div>
                {
                  subOpenIndex === _index ? leadingCriteria ?
                    <div role='cell' style={{ width : '100%'}}>
                        <Flex w={"100%"} gap={"sm"} mt={"sm"} align={"center"} justify={"center"}>
                          <p>Leading</p>
                          <AutomatedAuditLoader />
                        </Flex>
                    </div>
                    :
                    showPageDropDown && criteriaPages &&
                    criteriaPages.map((e: any, index: number) => {


                      const url = new URL(e.link);
                      const page = url.pathname.split('/').pop();
                      return <>
                        <div  id={e.id} key={index + '-' + e.id + '-' + e.link} className={`${'secnario-' + String(item?.id)} ${styles.pageRow}`}>
                          <div role='cell' style={{
                            paddingLeft: '75px'
                          }} className={styles.iconsTd}>
                            <UnstyledButton
                              style={{
                                backgroundColor: showIssue && showIssueIndex == index ? '#5b5eff' : 'white'
                              }}
                              onClick={() => {
                                setShowIssue(!showIssue);
                                setShowIssueIndex(index)

                                // if (showIssue) {
                                setIsselectedPageDataLoading(true)
                                showCriteriaPage(e.id)
                                // }

                              }} className={styles.circelBorder} aria-label={'close'} >
                              {showIssue && showIssueIndex == index ? <ChevronUp /> : <ChevronDown />}
                            </UnstyledButton>
                          </div>
                          <div role='cell'>
                            <Flex direction={"column"} justify={"center"} gap={"sm"} align={"start"} >
                              <Flex justify={"space-between"} align={"center"} wrap={"wrap"} gap={2}>
                                <strong>Title:</strong>
                                <p style={{ overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                                  {e.pageTitle ?? `${id} Page is missing title`}
                                </p>
                              </Flex>
                              <Flex justify={"space-between"} align={"center"} >
                                <strong>URL :</strong>
                                <a href={e.link} target='_blank'>
                                  {e.link}
                                </a>
                                {/* <UnstyledButton onClick={()=>handleCopy(e.link)} style={{marginLeft:"20px"}}>
                                  <Copy color={'#5b5eff'} size={20} aria-label="copy icon" />
                                </UnstyledButton> */}
                                {/* <Button color='gray-light'  onClick={() => navigate('?page=Issues By')} >
                                    Issues This Page
                                </Button> */}
                              </Flex>
                            </Flex>
                          </div>
                          <div role='cell' >{e.nbrOfIssues}</div>
                          <div role='cell'></div>
                          {/* <div role='cell'>
                            <Button  ariaLabel="Re-audit this page" color='dark-green' onClick={() => handleSinglePageAudit(e?.link) }>Re-audit</Button>
                          </div> */}
                        </div>
                        {showIssue && showIssueIndex === index && (
                          <>
                            {isselectedPageDataLoading ? (
                              <div>
                                <div
                                //  colSpan={6}
                                 >
                                  <Flex w="100%" gap="sm" mt="sm" align="center" justify="center">
                                    <p>Loading</p>
                                    <AutomatedAuditLoader />
                                  </Flex>
                                </div>
                              </div>
                            ) : selectedPageData ? (
                              <div style={{ marginTop : '1rem'}}>
                                <div 
                                role='cell'
                                // colSpan={7}
                                >
                                  <Accordion
                                    style={{
                                      padding: '10px',
                                      background: '#ffffff',
                                      border: '1px solid #dddd',
                                      borderRadius: '11px',
                                    }}
                                    w="90%"
                                    mx="auto"
                                    variant="contained"
                                    transitionDuration={300}
                                    chevronPosition="left"
                                  >
                                    {Object.entries(selectedPageData).map(([key, data]) => (
                                      <Accordion.Item key={data.id} value={`${data.id}-${key}`}>
                                        <Accordion.Control
                                          bg="#00000000"
                                          style={{ background: 'none' }}
                                        >
                                          {data.message}
                                        </Accordion.Control>
                                        <Accordion.Panel>
                                          <section
                                            style={{
                                              width: '100%',
                                              padding: '10px',
                                            }}
                                            className={styles.subRowContainer}
                                          >
                                            <div className={`${styles.subRow} ${styles.textCenter}`}>
                                              <h2>Description</h2>
                                              <p>{criteriaDescription}</p>
                                              <Link
                                                target="_blank"
                                                aria-label="open in new tab"
                                                className={styles.rowLink}
                                                to={`https://vially.io/services/wcag-${rowData?.criteriaCode?.replaceAll('.', '-')}`}
                                              >
                                                WCAG documentation: {rowData?.criteriaName}
                                                <ArrowUpRight />
                                              </Link>
                                              <Text my="sm">
                                                WCAG Criteria: {data.criteria} ({data.complianceLevel}{' '}
                                                Level)
                                              </Text>
                                              <Text mb="sm">
                                                <strong>Status:</strong> {data.status}
                                              </Text>
                                              <Text mb="sm">
                                                <strong>Message:</strong> {data.message}
                                              </Text>
                                              <Text mb="sm">
                                                <strong>Severity:</strong> {data.severity}
                                              </Text>
                                              <Text mb="sm">
                                                <strong>Issue Type:</strong> {data.issueType}
                                              </Text>
                                              <Text mb="sm">
                                                <strong>Score:</strong> {data.score}
                                              </Text>
                                              <List mt={4}>
                                                <Text>
                                                  <strong>Disabilities Affected:</strong>
                                                </Text>
                                                {data?.disabilities?.map((disability, idx) => (
                                                  <List.Item key={idx}>{disability}</List.Item>
                                                ))}
                                              </List>
                                            </div>
                                            <div className={`${styles.subRow} ${styles['image-column']}`}>
                                              {isselectedPageDataLoading && <SiteLoader />}
                                              {!isselectedPageDataLoading && selectedPageData ? (
                                                <Slider
                                                  afterChange={() => clearToolTip()}
                                                  {...sliderSettings}
                                                  className={styles.slider}
                                                >
                                                  {Object.entries(selectedPageData)
                                                    .slice(0, 1)
                                                    .map(([key, value]) => (
                                                      <div
                                                        key={value.id + value.pageUrl}
                                                        style={{ paddingInline: '1rem' }}
                                                      >
                                                        <div>
                                                          <span className={styles['detail-caption']}>
                                                            {c('pageScreenshot')}
                                                          </span>
                                                          {value.screenshot ? (
                                                            <img
                                                              className={styles.image}
                                                              src={value.screenshot}
                                                              alt={`${c('screenshot', { pageUrl: id })}`}
                                                            />
                                                          ) : (
                                                            <>
                                                              <Image />
                                                              <p>No Image Available</p>
                                                            </>
                                                          )}
                                                          <Space h={24} />
                                                          <div>
                                                            <Link
                                                              target="_blank"
                                                              aria-label="open in new tab"
                                                              className={styles.rowLink}
                                                              to={value.pageUrl}
                                                            >
                                                              View page
                                                              <ArrowUpRight />
                                                            </Link>
                                                          </div>
                                                          <Flex align="flex-end">
                                                            <Paper
                                                              className={styles['issue-context']}
                                                              bg="black"
                                                              shadow="none"
                                                              mt={24}
                                                              p="md"
                                                              radius={6}
                                                              style={{ width: '100%' }}
                                                              ref={widgetContainerRef}
                                                            >
                                                              {value.context}
                                                            </Paper>
                                                            <Space w={24} />
                                                            <Tooltip
                                                              label={`${t('scriptCopied')}`}
                                                              opened={openedTooltipIndex === Number(key)}
                                                              withArrow
                                                            >
                                                              <Flex className={styles.buttonCopy}>
                                                                <Button
                                                                  fullWidth
                                                                  aria-label={`${t('copyScriptLabel')}`}
                                                                  onClick={() =>
                                                                    handleCopyClick(value.context, Number(key))
                                                                  }
                                                                >
                                                                  <Copy size={20} aria-label="copy icon" />
                                                                </Button>
                                                              </Flex>
                                                            </Tooltip>
                                                          </Flex>
                                                          <Space w={24} h={24} />
                                                        </div>
                                                      </div>
                                                    ))}
                                                </Slider>
                                              ) : (
                                                <div className={styles.emptyData}>
                                                  <EmptyTable />
                                                  <p>No page URLs exist</p>
                                                </div>
                                              )}
                                            </div>
                                          </section>
                                        </Accordion.Panel>
                                      </Accordion.Item>
                                    ))}
                                  </Accordion>
                                  <Space h="sm" />
                                </div>
                              </div>
                            ) : (
                              <div>
                                <div 
                                // colSpan={7}
                                >
                                  <Space h="md" />
                                  <p className={styles.emptyData}>No data found.</p>
                                </div>
                              </div>
                            )}
                          </>
                        )}

                      </>
                    }
                    )
                    : null
                }
              </>
            );
          })}
        </>
      )}
    </>
  );
};
interface TableHeaderProps {
  handleSortingApi: (field: string, order: string) => void;
}

const TableHeader: FC<TableHeaderProps> = ({ handleSortingApi }): JSX.Element => {

  const [t] = useTranslation('automatedReports');
  const [order, setOrder] = useState('asc');
  const [sortField, setSortField] = useState<string | null>(null);

  const handleSorting = (field: string) => { 
    const isAsc = sortField === field && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setSortField(field);
    handleSortingApi(field, order);

  };




  return (
    <Flex role="columnheader" className={classNames(styles['table-header'])}  >
      {/* <div> */}
        <p className={styles.flex}></p>
        <p className={styles.flex}>WCAG Criteria
          {/* <ChevronDown/> */}
        </p>


        <p className={styles.flex} > Issues
          <Button
              className={styles.orderBtn}
              buttonStyle={{backgroundColor:'transparent',color:"black"}}
              ariaLabel="Reorder rows based on the issues"
              onClick={() => handleSorting('issues')}>
              { (order == 'asc' && sortField == 'issues' ) ? <ChevronDown/> : <ChevronUp/> }
          </Button>
          {/* <ChevronDown/> */}
        </p>


        <p className={styles.flex} > Pages
          <Button
                className={styles.orderBtn}
                buttonStyle={{backgroundColor:'transparent',color:"black"}}
                ariaLabel="Reorder rows based on the pages"
                // color="dark-green" // Use a valid color value as defined in the component's API
                onClick={() => handleSorting('pages')}                   >
              { (order == 'asc' && sortField == 'pages' ) ? <ChevronDown/> : <ChevronUp/> }
          </Button>
          {/* <ChevronDown/> */}
        </p>


        <p className={styles.flex}> Priority
          <Button
                className={styles.orderBtn}
                buttonStyle={{backgroundColor:'transparent',color:"black"}}
                ariaLabel="Reorder rows based on the priority"
                // color="dark-green" // Use a valid color value as defined in the component's API
                onClick={() => handleSorting('priority')}                   >
               { (order == 'asc' && sortField == 'priority' ) ? <ChevronDown/> : <ChevronUp/> }
          </Button>
          {/* <ChevronDown/> */}
        </p>


        {/* <th className={styles.flex}>Total Impact <ChevronDown/></th> */}
        {/* <th className={styles.flex}>Action</th> */}
      {/* </div> */}
    </Flex>
  );
};

const TableBody: FC<TableReportProps> = ({ report }): JSX.Element => {

  const { id, tracking_number, runId } = useParams();
  const { tenantId } = useAppSelector((state) => state.user.data, shallowEqual);

  const [currentReport, setCurrentReport] = useState(report);

  useEffect(() => {
    setCurrentReport(report);
  }, [report])
  

  useEffect(() => {

    const getcriteriatotal = async () => {
      try {

        const data: any = await apiInstance.post(`reporttool/v1/getcriteriatotal`, { tenantId, siteId: id, trackingNumber: tracking_number, reportId: runId });
        if (data.data.statusCode != 200) {
          throw 'error';
        }

        const criteriaTotalNumb = data.data.body.criterias;


        const issuesMap = criteriaTotalNumb?.reduce((acc: any, curr: any) => {
          acc[curr.criteria] = curr.nbrOfIssues;
          return acc;
        }, {});


        const updatedSecondArray = currentReport.map((item: any) => {
          if (issuesMap[item.criteriaCode] !== undefined) {
            return { ...item, nbrOfIssues: issuesMap[item.criteriaCode] };
          }
          return item;
        });

        setCurrentReport(updatedSecondArray);
      } catch (error) {
        console.log(error);
      }
    }

    getcriteriatotal()

  }, [])

  return (
    <div className={` ${styles.tabelMobile} ${styles.tbodyContainer}`}>
      {currentReport.map((e, i) => (
        <TableRow key={e.id + i} rowIndex={i} rowData={e} />
      ))}
    </div>
  );
};

const Table: FC<TableReportProps> = ({ report }): JSX.Element => {

    const [currentReport, setCurrentReport] = useState(report);
  
    useEffect(() => {
      setCurrentReport(report);
    }, [report]);
  
    // const handleSortingApi = (field: string, order: string) => {
    //   const sortedArray = [...currentReport].sort((a: any, b: any) => {
    //     let valueA = a[field];
    //     let valueB = b[field];
    
    //     // Handle nested fields if necessary
    //     if (field === "issues") {
    //       valueA = a.nbrOfIssues; // Assuming `nbrOfIssues` corresponds to "issues"
    //       valueB = b.nbrOfIssues;
    //     } else if (field === "priority") {
    //       valueA = a.priority; // Add if you have a priority field
    //       valueB = b.priority;
    //     } else if (field === "pages") {
    //       valueA = a.pages; // Add if you have a pages field
    //       valueB = b.pages;
    //     }
    
    //     // Sorting logic for numbers
    //     if (typeof valueA === "number" && typeof valueB === "number") {
    //       return order === "asc" ? valueA - valueB : valueB - valueA;
    //     }
    
    //     // Sorting logic for strings
    //     if (typeof valueA === "string" && typeof valueB === "string") {
    //       return order === "asc"
    //         ? valueA.localeCompare(valueB)
    //         : valueB.localeCompare(valueA);
    //     }
    
    //     // Default if the types are not comparable
    //     return 0;
    //   });
    //   console.log('sortedArray');
    //   console.log(sortedArray);
    //   console.log('sortedArray');
      
    //   setCurrentReport(sortedArray); // Update the state with the sorted array
    // };


    const handleSortingApi = (field: string, order: string) => {
      console.log(`Sorting by field: ${field}, order: ${order}`);
  
      const priorityMap:any = {
          "Low": 1,
          "Medium": 2,
          "Warning": 3,
          "High": 4,
      };
  
      const sortedArray = [...currentReport].sort((a: any, b: any) => {
          let valueA = a[field];
          let valueB = b[field];
  
          // Handle custom fields
          if (field === "issues") {
            valueA = a.nbrOfIssues;
            valueB = b.nbrOfIssues;
          } else if (field === "priority") {
            valueA = priorityMap[a.severity] || 0; // Default to 0 if not found
            valueB = priorityMap[b.severity] || 0;
          } else if (field === "pages") {
            valueA = a.pages;
            valueB = b.pages;
          }
  
          // Log comparison values
          console.log(`Comparing: ${valueA} vs ${valueB}`);
  
          // Compare using the mapped priorities
          return order === "asc" ? valueA - valueB : valueB - valueA;
      });
  
      setCurrentReport(sortedArray);
  };

  
  return (
    <table id="issues-table" className={classNames(styles.table)} cellSpacing="0" >
      <TableHeader handleSortingApi={handleSortingApi}></TableHeader> 
      <TableBody report={currentReport} ></TableBody>
    </table>
  );
};

export default Table;
